import axios from 'axios';
import { API_URL } from '../../config/api';

// Configurar axios com interceptors para token
const api = axios.create({
  baseURL: API_URL
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use((config) => {
  // Usar a mesma lógica do AuthContext
  const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para tratar erros de resposta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token inválido - limpar dados de autenticação
      localStorage.removeItem('auth_token');
      localStorage.removeItem('token');
      localStorage.removeItem('user_data');
      // Redirecionar para login se necessário
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export const BankAccountService = {
  // Buscar todas as contas bancárias do usuário
  async getUserBankAccounts() {
    const response = await api.get('/api/bank-accounts');
    return response.data;
  },

  // Criar nova conta bancária
  async createBankAccount(accountData) {
    const response = await api.post('/api/bank-accounts', accountData);
    return response.data;
  },

  // Atualizar conta bancária
  async updateBankAccount(accountId, accountData) {
    const response = await api.put(`/api/bank-accounts/${accountId}`, accountData);
    return response.data;
  },

  // Deletar conta bancária (soft delete)
  async deleteBankAccount(accountId) {
    const response = await api.delete(`/api/bank-accounts/${accountId}`);
    return response.data;
  },

  // Definir conta como padrão
  async setDefaultAccount(accountId) {
    const response = await api.put(`/api/bank-accounts/${accountId}/set-default`);
    return response.data;
  },

  // Buscar lista de bancos disponíveis
  async getBanks() {
    const response = await api.get('/api/banks');
    return response.data;
  },

  // ========================================
  // 🛡️ ADMIN - APROVAÇÃO DE CONTAS
  // ========================================

  // Buscar contas pendentes de aprovação (ADMIN)
  async getPendingBankAccounts() {
    const response = await api.get('/api/bank-accounts-admin/pending');
    return response.data;
  },

  // Buscar todas as contas com filtros (ADMIN)
  async getAllBankAccounts(filters = {}) {
    const params = new URLSearchParams();
    if (filters.approval_status) params.append('approval_status', filters.approval_status);
    if (filters.user_id) params.append('user_id', filters.user_id);
    
    const response = await api.get(`/api/bank-accounts-admin/all?${params.toString()}`);
    return response.data;
  },

  // Aprovar conta bancária (ADMIN)
  async approveBankAccount(accountId) {
    const response = await api.put(`/api/bank-accounts-admin/${accountId}/approve`);
    return response.data;
  },

  // Rejeitar conta bancária (ADMIN)
  async rejectBankAccount(accountId, rejectionReason = '') {
    const response = await api.put(`/api/bank-accounts-admin/${accountId}/reject`, {
      rejection_reason: rejectionReason
    });
    return response.data;
  },

  // Buscar estatísticas de contas (ADMIN)
  async getBankAccountsStats() {
    const response = await api.get('/api/bank-accounts-admin/stats');
    return response.data;
  }
};

export default BankAccountService;
